import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-on-off-switcher',
  templateUrl: './on-off-switcher.component.html',
  styleUrls: ['./on-off-switcher.component.scss']
})
export class OnOffSwitcherComponent {
  @Input() value = false;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<boolean>();

  onToggle(event: Event) {
    if (this.disabled) {
      return;
    }

    const checked = (event.target as HTMLInputElement).checked;
    this.valueChange.emit(checked);
  }
}
